export default class RecaptchaManager {
  private static getSiteKey(sitekeyOverride?: string) {
    if (sitekeyOverride != null) {
      return sitekeyOverride;
    }

    const devSitekey = '6LdtfVMqAAAAAMurhtf2pDhK0oqD4eLqeQPh025y';
    const prodSitekey = '6LeYqFcqAAAAAD6iZesmNgVulsO4PkpBdr6NVG6M';
    return process.env.NODE_ENV === 'production' ? prodSitekey : devSitekey;
  }

  // Load recaptcha script, injecting the script tag into the dom
  public static loadRecaptchaScript(sitekeyOverride?: string, onloadCallback?: () => void) {
    const element = document.getElementById(`recaptcha-script-${this.getSiteKey(sitekeyOverride)}`);

    if (element != null) {
      if (onloadCallback != null) {
        onloadCallback();
      }
      return;
    }

    const script = document.createElement('script');

    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.getSiteKey(sitekeyOverride)}`;
    script.id = `recaptcha-script-${this.getSiteKey(sitekeyOverride)}`;
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    if (onloadCallback != null) {
      script.onload = () => {
        onloadCallback();
      };
    }
  }
}
